import { Mark } from 'tiptap';
import { updateMark, removeMark, pasteRule } from 'tiptap-commands';

export default class SeoLink extends Mark {

    get name() {
        return 'seolink';
    }

    get defaultOptions() {
        return {
            openOnClick: false,
        }
    }

    get schema() {
        return {
            attrs: {
                href:   { default: null },
                title:    { default: null },
                target: { default: null },
                rel: { default: null }
            },
            inclusive: false,
            parseDOM: [
                {
                    tag: 'a[href]',
                    getAttrs: dom => ({
                        href:   dom.getAttribute('href'),
                        title:    dom.getAttribute('title'),
                        target: dom.getAttribute('target'),
                        rel: dom.getAttribute('rel')
                    }),
                },
            ],
            toDOM: node => ['a', {
                    ...node.attrs
                }, 0]
        }
    }

    commands({ type }) {
        return attrs => {
            if(!attrs.href && !attrs.title) {
                return removeMark(type);
            }
            return updateMark(type, attrs);
        }

    }

    pasteRules({ type }) {
        return [
            pasteRule(
                /https?:\/\/(www\.)?[-a-zA-Z0-9@:%._+~#=]{2,256}\.[a-zA-Z]{2,}\b([-a-zA-Z0-9@:%_+.~#?&//=]*)/g,
                type,
                (url, title, target, rel) => ({ href: url, title: title, target:target, rel:rel }),
            ),
        ]
    }
}
